import { createBrowserHistory, createMemoryHistory, History, MemoryHistory } from 'history';
import { parse, stringify } from 'qs';
import { unset } from 'lodash/fp';
import qhistory from 'qhistory';

import getIsServer from '../utils/get-is-server';

const createHistory = (initialPath: string) => {
  let history: MemoryHistory | History<unknown>;

  const isServer = getIsServer();
  if (isServer) {
    const opts = initialPath ? { initialEntries: [initialPath] } : undefined;
    history = createMemoryHistory(opts);
  } else {
    history = createBrowserHistory();
  }
  const result = qhistory(history, stringify, parse);

  if (result?.location?.state === undefined) {
    // this fixes an issue with serialising history during SSR
    return unset('location.state', result);
  }
  return result;
};

export default createHistory;
